import { CloudKeysDto } from 'src/Libs/installation-rights-management/dto'
import { CloudKeyModel } from 'src/Libs/installation-rights-management/models'

/**
 * Returns a list of CloudKeyModel from a "object as array"-structure.
 *
 * Apply value casts on each property to ensure that the defined values are in the expected type, because we
 * can't neither trust the api nor it's documentation .
 *
 * @param values
 */
const cloudKeysDtoToModelTransformer = (values: CloudKeysDto): CloudKeyModel[] => {
  return values.id.map((id, index) => ({
    id: Number(id),
    createdAt: values.createdAt[index] ? `${values.createdAt[index]}` : '',
    updatedAt: values.updatedAt[index] ? `${values.updatedAt[index]}` : '',
    installationId: values.installationId[index] ? Number(values.installationId[index]) : -1,
    key: values.key[index] ? `${values.key[index]}` : '',
    accountLinkId: values.createdAt[index] ? Number(values.accountLinkId[index]) : -1,
    inUse: values.inUse[index] ? Boolean(values.inUse[index]) : false,
    description: values.description[index] ? `${values.description[index]}` : '',
    scope: values.scope[index],
    isDeletable: values.isDeleteable[index] ? Boolean(values.isDeleteable[index]) : false,
  }))
}

export default cloudKeysDtoToModelTransformer
